import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ResponsiveAppBar from './components/navbar';
import Footer from './components/Footer'; // Import the Footer component
import Home from './components/home';
import About from './components/about';
import Wellness from './components/wellness';
import Payments from './components/payments';
import Blog from './components/Blog';

function App() {
  return (
    <Router>
      <ResponsiveAppBar />
      <div style={{ minHeight: 'calc(100vh - 100px)' }}> {/* Ensure footer doesn't overlap */}
        <Routes>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/wellness" element={<Wellness />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/blog" element={<Blog />} />
        </Routes>
      </div>
      <Footer /> {/* Add Footer here */}
    </Router>
  );
}

export default App;